import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getUxFeedbackFeatures<FeatureName>(): Promise<FeatureName[]> {
    const { apiGetUxFeedbackFeatures } = apiConfig.getStaticUrls();

    return getFetch(apiGetUxFeedbackFeatures);
}
